export default __webpack_public_path__ + "assets/images/High-Commissions-3f424603f452633074e2e0bbca965911.svg";